import { ol, ul } from './helpers';
import { IMPLEMENTATION_PLAN_NAMES, STAGES_NAMES } from '../Sections/ImplementationPlan/utils/form';

const STAGES_INSTRUCTIONS = {
  [STAGES_NAMES.STAGE]: {
    name: 'Implementation plan',
    instruction:
      'When addressing inquiries about the project timeline, follow these steps:' +
      ol([
        'Outline key stages from concept to launch.',
        'Specify estimated durations for each stage.',
        'Indicate what stage you are currently at.',
      ]),
    exampleOne: ul([
      'Concept & Design: 6 months.',
      'Prototyping & Testing: 9 months.',
      'Manufacturing Setup: 3 months.',
      'Marketing & Launch Preparation: 2 months.',
      'Currently in the manufacturing setup stage.',
    ]),
    exampleTwo: ul([
      'Concept phase: 3 months.',
      'Design and prototyping: 6 months.',
      'Testing and iteration: 4 months.',
      'Finalization and production: 3 months.',
      'Currently in testing and iteration stage.',
    ]),
  },
};

export const IMPLEMENTATION_PLAN_SECTION_INSTRUCTIONS = {
  [IMPLEMENTATION_PLAN_NAMES.STAGES]: STAGES_INSTRUCTIONS,
};
